import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollableModule } from '@app/common/scrollable';
import { TicketTopicListComponent } from './ticket-topic-list.component';

@NgModule({
  declarations: [ TicketTopicListComponent ],
  imports: [
    CommonModule,
    MatCardModule,
    MatListModule,
    MatButtonModule,
    MatDividerModule,
    MatRippleModule,
    ScrollableModule,
    TranslateModule.forChild()
  ],
  exports: [ TicketTopicListComponent ]
})
export class TicketTopicListModule {

}
